export const stylingFunctions = {
    ALIGN: (_state, alignment, value) => `<p style="text-align: ${alignment};" class="wixui-rich-text__text">${value}</p>`,
    SPACES: (_state, value) => '&nbsp;'.repeat(Number(value)),
    STRIKE: (state, value) => maybeWrapWithP(state, `<span style="text-decoration: line-through" class="wixui-rich-text__text">${value}</span>`),
    UNDERLINE: (state, value) => maybeWrapWithP(state, `<span style="text-decoration: underline" class="wixui-rich-text__text">${value}</span>`),
    ITALIC: (state, value) => maybeWrapWithP(state, `<span style="font-style: italic" class="wixui-rich-text__text">${value}</span>`),
    BOLD: (state, value) => maybeWrapWithP(state, `<span style="font-weight: bold" class="wixui-rich-text__text">${value}</span>`),
    HIGHLIGHT: (state, color, value) => maybeWrapWithP(state, `<span style="background-color: ${color}" class="wixui-rich-text__text">${value}</span>`),
    COLOR: (state, color, value) => maybeWrapWithP(state, `<span style="color: ${color}" class="wixui-rich-text__text">${value}</span>`),
};
export const isItAStylingFunction = (expression) => typeof expression.name === 'string' && expression.name in stylingFunctions;
const isThereOrAboveAStylingFunction = (state) => {
    if (state === undefined) {
        return false;
    }
    if (isItAStylingFunction(state)) {
        return true;
    }
    return isThereOrAboveAStylingFunction(state.parentFunction);
};
function maybeWrapWithP(state, html) {
    return isThereOrAboveAStylingFunction(state.parentFunction)
        ? html
        : `<p class="wixui-rich-text__text">${html}</p>`;
}
//# sourceMappingURL=stylingFunctions.js.map